import * as React from 'react';
import { SVGProps } from 'react';

const IconHelmetSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 15.5V12a7 7 0 0 0-4.033-6.342 1.344 1.344 0 0 0-.39-.735c-.35-.34-.873-.55-1.54-.69C14.346 4.09 13.375 4 12 4s-2.346.09-3.037.234c-.667.138-1.19.35-1.54.689a1.345 1.345 0 0 0-.39.735A7 7 0 0 0 3 12v3.5A2.5 2.5 0 0 0 4.5 20h15a2.5 2.5 0 0 0 1.5-4.5ZM9.073 6.266l.907 4.538a1 1 0 0 1-1.96.392L7.333 7.77A4.996 4.996 0 0 0 5 12v3h14v-3a4.997 4.997 0 0 0-2.334-4.23l-.686 3.426a1 1 0 1 1-1.96-.392l.907-4.538a3.628 3.628 0 0 0-.297-.074C14.124 6.087 13.303 6 12 6s-2.124.087-2.63.192c-.122.025-.22.05-.297.074ZM4.494 17h15.012a.5.5 0 0 1-.006 1h-15a.5.5 0 0 1-.006-1Z"
    />
  </svg>
);
export default IconHelmetSizeM;
